import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { loadStoreState, setInitialStoreState } from '../../../../../../common/utils';
import { ClosedPeriodItemFacade } from './closed-period-item.facade';

@Injectable({
  providedIn: 'root',
})
export class ClosedPeriodItemGuard {
  constructor(private closedPeriodFacade: ClosedPeriodItemFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return loadStoreState(this.closedPeriodFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.closedPeriodFacade);
  }
}
